import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import Container from "@mui/material/Container";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";

// import { FormContainer, TextFieldElement } from "react-hook-form-mui";

const Starters = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp } = itemOptions;
    const { t } = i18n;
    let { state } = useLocation();
    let { code: tmpCode } = useParams();
    const [loading, setLoading] = useState(true);
    const [starters, setStarters] = useState([]);
    const [code, setCode] = useState("");

    const [chosen, setChosen] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        let code2 = "";
        if (state !== undefined && state !== null) {
            // setCode(state.code);
            code2 = state.code;
        }
        if (tmpCode !== undefined && tmpCode !== null) {
            // setCode(tmpCode);
            code2 = tmpCode;
        }
        if (comp.status.registrationOpen === false && code2 === "") {
            navigate("/");
            // console.log("navigate to root");
        } else if (comp.status.registrationOpen === false && code2 !== "") {
            axios
                .put(`${api.checkCode}${comp.id}`, { code: code2 })
                .then(res => {
                    if (res.status === 200) {
                        setCode(code2);
                    } else {
                        navigate("/");
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    navigate("/");
                });
        }

        axios.get(`${api.getClubStarters}0`).then(res => {
            setStarters(res.data);
        });
        setLoading(false);
    }, []);
    // console.log(starters);
    const renderOption = (props, option) => {
        if (option.starterType === "formation") {
            return (
                <li {...props}>
                    <Stack direction="column" spacing={0}>
                        <Typography variant="body1">{option.name}</Typography>
                        <Typography variant="body2" color="textSecondary">
                            {option.athletes.join(", ")}
                        </Typography>
                    </Stack>
                </li>
            );
        } else {
            return <li {...props}>{option.name}</li>;
        }
    };
    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.pzst.starters")}</h2>
            <p>{t("reg.info.starters")}</p>

            <Container maxWidth="xs" className="mb-2">
                <Box>
                    <form>
                        <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 4 }}>
                            {!loading && (
                                <Autocomplete
                                    id="startersSelect"
                                    options={starters?.sort((a, b) => -b.club.localeCompare(a.club))}
                                    groupBy={option => option.club}
                                    getOptionLabel={option => option.name}
                                    value={chosen}
                                    renderOption={renderOption}
                                    onChange={(event, newValue) => {
                                        setChosen(newValue);
                                    }}
                                    // sx={{ width: 300 }}
                                    renderInput={params => <TextField {...params} label={t("reg.pzst.choose_starter")} />}
                                />
                            )}
                            {!loading && (
                                <Link
                                    to="/categories"
                                    state={{
                                        person1: null,
                                        person2: null,
                                        couple: null,
                                        team: null,
                                        email: null,
                                        fromWdsf: false,
                                        fromPzst: true,
                                        fromForm: false,
                                        starters: chosen,
                                        code: code
                                    }}
                                >
                                    <Button type="submit" variant="contained" startIcon={<HowToRegIcon />} fullWidth disabled={chosen === null}>
                                        {t("reg.wdsf.continue")}
                                    </Button>
                                </Link>
                            )}
                            {loading && <LinearProgress />}
                        </Stack>
                    </form>
                </Box>
            </Container>
        </React.Fragment>
    );
};

export default Starters;
